/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateCouponBatchShopifyProductsTarget { 
    /**
     * Target specific products or product variants.
     */
    type: CreateCouponBatchShopifyProductsTarget.TypeEnum;
    /**
     * Shopify Product GIDs to target.
     */
    productIds?: Array<string>;
    /**
     * Shopify ProductVariant GIDs to target.
     */
    productVariantIds?: Array<string>;
}
export namespace CreateCouponBatchShopifyProductsTarget {
    export const TypeEnum = {
        Products: 'products'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


